/** @format */

/**
 * Structure of the data stored in the TAG_IDs local storage key.
 * This has similar data to but is structured differently than `window._dsgTag.CustomerIDs`
 */
export interface TagIDs {
  AdobeMCVID: BaseTagID;
  AthleteID: AthleteTagID;
  CustomerKey: BaseTagID;
  DeviceID: BaseTagID;
  HashedEmail: BaseTagID;
  IdentityID: BaseTagID;
  Loyalty: LoyaltyTagID;
  Webstore: BaseTagID;
}

type BaseTagID =
  | { ID: ''; lastUpdated: number | ''; source?: string }
  | { ID: string; lastUpdated: number; source: string };

type LoyaltyTagID = BaseTagID & {
  isGold: boolean;
  goldExpires: number;
};

type AthleteTagID = BaseTagID & {
  lastAPICheck: number;
};
